"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@eres/core");
var LocaleValue_1 = require("@eres/core/dist/LocaleValue");
function toNormalizedLocaleValue(x) {
    if (x == null)
        return null;
    var r = {};
    for (var _i = 0, _a = Object.keys(LocaleValue_1.langKeyMap); _i < _a.length; _i++) {
        var langKey = _a[_i];
        r[langKey] = core_1.LocaleUtil.getLocalValue(x, langKey);
    }
    return r;
}
exports.toNormalizedLocaleValue = toNormalizedLocaleValue;
function normalizeError(x) {
    var _a, _b, _c;
    if (x == null)
        return null;
    var msgSet = (_a = x.errorMessageSet) !== null && _a !== void 0 ? _a : x.ErrorMessageSet;
    return {
        errorMessage: (_b = x.errorMessage) !== null && _b !== void 0 ? _b : x.ErrorMessage,
        errorNumber: (_c = x.errorNumber) !== null && _c !== void 0 ? _c : x.ErrorNumber,
        errorMessageSet: toNormalizedLocaleValue(msgSet),
    };
}
function getNormalizedErrors(x) {
    if (x == null)
        return null;
    var e = [];
    if (Array.isArray(x) && x.length > 0) {
        for (var _i = 0, x_1 = x; _i < x_1.length; _i++) {
            var xi = x_1[_i];
            var ne = normalizeError(xi);
            if (ne != null)
                e.push(ne);
        }
    }
    return e;
}
function validator(erorrKey) {
    return function (response) {
        var _a, _b;
        if (response == undefined)
            return Promise.reject(new Error("Empty response"));
        var rs = response;
        var r = (_a = rs === null || rs === void 0 ? void 0 : rs.response) !== null && _a !== void 0 ? _a : rs === null || rs === void 0 ? void 0 : rs.Response;
        var ex = erorrKey ? rs[erorrKey] : (_b = rs.validationErrorsList) !== null && _b !== void 0 ? _b : rs.ValidationErrorsList;
        var err = getNormalizedErrors(ex);
        if (err && err.length > 0) {
            var message = err.reduce(function (previousValue, currentValue) {
                if (currentValue.errorMessageSet) {
                    return previousValue + "\n" + core_1.LocaleUtil.getLocalValue(currentValue.errorMessageSet);
                }
                else {
                    return previousValue + "\n" + currentValue.errorNumber + ":" + currentValue.errorMessage;
                }
            }, "");
            var ex_1 = new Error(message.trim());
            ex_1.data = err;
            return Promise.reject(ex_1);
        }
        return Promise.resolve(r);
    };
}
exports.validator = validator;
/**
 @deprecated use new validator
 */
function validateResponse(response) {
    if (response == undefined)
        return Promise.reject("Empty response");
    if (response.validationErrorsList && response.validationErrorsList.length > 0) {
        var message = response.validationErrorsList.reduce(function (previousValue, currentValue) {
            if (currentValue.errorMessageSet) {
                return previousValue + "\n" + core_1.LocaleUtil.getLocalValue(currentValue.errorMessageSet);
            }
            else {
                return previousValue + "\n" + currentValue.errorNumber + ":" + currentValue.errorMessage;
            }
        }, "");
        return Promise.reject(message.trim());
    }
    return Promise.resolve(response.response);
}
exports.validateResponse = validateResponse;
/**
 @deprecated use new validator
 */
function validateResponseX(response) {
    if (response == undefined)
        return Promise.reject("Empty response");
    if (response.ValidationErrorsList && response.ValidationErrorsList.length > 0) {
        var message = response.ValidationErrorsList.reduce(function (previousValue, currentValue) {
            if (currentValue.ErrorMessageSet) {
                return previousValue + "\n" + core_1.LocaleUtil.getLocalValue(currentValue.ErrorMessageSet);
            }
            else {
                return previousValue + "\n" + currentValue.ErrorNumber + ":" + currentValue.ErrorMessage;
            }
        }, "");
        return Promise.reject(message.trim());
    }
    return Promise.resolve(response.Response);
}
exports.validateResponseX = validateResponseX;
